module.exports = __webpack_public_path__ + "img/About_Employers_LIGHT-05.ba1a59b.svg";